export class DynamicFormTemplateBo {
    orderColumn: string = "name";
    currentpageno: number = 1;
    pageitem: number = 10;
    orderType: string = "asc";
    type: string = "string";
    field: string = "name";
    operator: string = "contains";
    value: string = "";
    entityTypeCode: string;
    matchCase: boolean = false;
    agencyId: number | null;
    groupNameLid:any | null;

}


export class saveTemplateBo {
    id:string='00000000-0000-0000-0000-000000000000'
    entityTypeCode: string = "";
    documentName: string = "";
    name: string = "";
    documentType: string = "";
    template: any;
    agencyId: number | null;
    group:number;
    groupNameLid:any | null;

}
export class DynamicFormTemplateConfigurationBO {
    entityTypeCode: string;
    dynamicFormTemplateId: string;
    name: string;
    formFields: DynamicFormFieldBO[];
}
export class DynamicFormFieldBO {
    id: string;
    formFieldName: string;
    dynamicFormDataDictionaryId: string | null;
    defaultValue: string;
}

export class functionpermission {
    dynamicformtemplatedelete: boolean = true;

}


export class LovBO {
    id: number;
    lovCode: string;
    lovName: string;
    lovValue: string;
    listId: number;
    orderby: number;
    agencyId: number | null;
}


